import * as React from 'react';

export function IconDiscover(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 51 32" fill="none" {...props}>
      <title>Discovery Card</title>
      <g clipPath="url(#prefix__clip0_16_27)">
        <path
          opacity={0.07}
          d="M46.667 0H4C1.733 0 0 1.733 0 4v24c0 2.267 1.867 4 4 4h42.667c2.266 0 4-1.733 4-4V4c0-2.267-1.867-4-4-4z"
          fill="#212427"
        />
        <path
          d="M46.667 1.333c1.466 0 2.666 1.2 2.666 2.667v24c0 1.467-1.2 2.667-2.666 2.667H4A2.675 2.675 0 011.333 28V4c0-1.467 1.2-2.667 2.667-2.667h42.667z"
          fill="#fff"
        />
        <path
          d="M4.76 9.547H2.667v7.333H4.76c1.107 0 1.907-.267 2.613-.84a3.667 3.667 0 001.334-2.813c-.014-2.174-1.627-3.68-3.947-3.68zm1.68 5.52c-.453.4-1.027.586-1.96.586h-.387V10.8h.387c.92 0 1.48.16 1.96.587.493.44.787 1.12.787 1.826 0 .707-.294 1.414-.787 1.854zm2.92-5.52h1.427v7.333H9.36V9.547zm4.92 2.813c-.853-.32-1.107-.533-1.107-.92 0-.467.454-.813 1.067-.813.427 0 .787.173 1.147.6l.746-.974a3.225 3.225 0 00-2.16-.813c-1.293 0-2.293.907-2.293 2.107 0 1.013.467 1.533 1.8 2.013.56.2.84.333.987.413.28.187.426.454.426.76 0 .6-.466 1.04-1.106 1.04-.68 0-1.227-.346-1.56-.973l-.92.893c.653.974 1.453 1.4 2.533 1.4 1.48 0 2.533-.986 2.533-2.413.027-1.187-.466-1.72-2.093-2.32zm2.56.867c0 2.16 1.693 3.826 3.867 3.826.613 0 1.146-.12 1.786-.426v-1.68c-.573.573-1.08.8-1.72.8-1.44 0-2.466-1.04-2.466-2.534 0-1.413 1.053-2.52 2.4-2.52.68 0 1.2.24 1.786.827V9.84c-.626-.32-1.146-.453-1.76-.453-2.146 0-3.893 1.706-3.893 3.84zm17.013 1.253l-1.96-4.933h-1.56l3.107 7.52h.773l3.16-7.52h-1.546l-1.974 4.933zm4.174 2.4h4.053v-1.24h-2.627v-1.973h2.534v-1.24h-2.534V10.8h2.627V9.547h-4.053v7.333zm9.72-5.16c0-1.373-.947-2.16-2.6-2.16h-2.12v7.333h1.426v-2.946h.187l1.973 2.946h1.76L46.067 13.8c1.08-.227 1.68-.96 1.68-2.08zm-2.88 1.213h-.414v-2.226h.44c.894 0 1.374.373 1.374 1.093 0 .733-.48 1.133-1.4 1.133z"
          fill="#231F20"
        />
        <path
          d="M26.88 17.147a3.908 3.908 0 100-7.816 3.908 3.908 0 000 7.816z"
          fill="url(#prefix__paint0_linear_16_27)"
        />
        <path
          opacity={0.65}
          d="M26.88 17.147a3.908 3.908 0 100-7.816 3.908 3.908 0 000 7.816z"
          fill="url(#prefix__paint1_linear_16_27)"
        />
        <path
          d="M48.76 10.008c0-.133-.093-.2-.24-.2h-.213v.64h.16v-.253l.186.253h.187l-.213-.267c.08-.013.133-.08.133-.173zm-.267.093h-.026v-.173h.026c.08 0 .12.027.12.08 0 .067-.04.093-.12.093z"
          fill="#231F20"
        />
        <path
          d="M48.547 9.568a.563.563 0 00-.56.56c0 .307.253.56.56.56.306 0 .56-.253.56-.56a.563.563 0 00-.56-.56zm0 1.027c-.24 0-.454-.2-.454-.467 0-.253.2-.467.454-.467.24 0 .44.214.44.467s-.2.467-.44.467z"
          fill="#231F20"
        />
        <path
          d="M49.333 17.312S36.12 26.497 11.968 30.667h34.697a2.667 2.667 0 002.667-2.646l.032-4.026-.03-6.682v-.001z"
          fill="#F48120"
        />
      </g>
      <defs>
        <linearGradient
          id="prefix__paint0_linear_16_27"
          x1={28.876}
          y1={16.367}
          x2={26.176}
          y2={12.139}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F89F20" />
          <stop offset={0.25} stopColor="#F79A20" />
          <stop offset={0.533} stopColor="#F68D20" />
          <stop offset={0.62} stopColor="#F58720" />
          <stop offset={0.723} stopColor="#F48120" />
          <stop offset={1} stopColor="#F37521" />
        </linearGradient>
        <linearGradient
          id="prefix__paint1_linear_16_27"
          x1={28.451}
          y1={16.309}
          x2={24.504}
          y2={8.595}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F58720" />
          <stop offset={0.359} stopColor="#E16F27" />
          <stop offset={0.703} stopColor="#D4602C" />
          <stop offset={0.982} stopColor="#D05B2E" />
        </linearGradient>
        <clipPath id="prefix__clip0_16_27">
          <path fill="#fff" d="M0 0h50.667v32H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
